import { connect } from 'react-redux';
import VerifyEmailComponent from '../components/VerifyEmailComponent';
import action from '../redux/actions/login';

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  onVerifyEmail: (params) => {
    dispatch(action.verifyEmail(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmailComponent);
